import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
// import SettingsIcon from '@material-ui/icons/Settings';
import classNames from 'classnames';
import queryString from 'query-string';
import _ from 'lodash';
import { Text } from 'recharts';
import Header from '../../components/Header';
import PublicHeader from '../../components/PublicHeader';
import MenuRegisterButton from '../../components/atoms/MenuRegisterButton';
import MenuViewOrderEditButton from '../../components/atoms/MenuViewOrderEditButton';
import GochiMenuTableShop from '../organisms/GochiMenuTableShop';
import GochiChildFoodShop from '../organisms/GochiChildFoodShop';
import GochiMenuAddShop from '../organisms/GochiMenuAddShop';
import MenuViewOrderCustomShop from '../organisms/MenuViewOrderCustomShop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochiMenus,
  getOrderGochiMenus,
  downloadMenu,
  getMenuSetting,
  updateMenuSetting
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import { getShops } from '../../actions/Shop';
import MenuBox from '../../components/MenuBox';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import GochiChildFoodListAddShop from '../organisms/GochiChildFoodListAddShop';
import {
  getGochiChildFoodLists,
  getChildFoodShops,
  getChildFoodGroups
} from '../../actions/GochiChildFoodLists';
import ShowHideSwitchButton from '../../components/atoms/ShowHideSwitchButton';
import MenuSetting from '../organisms/MenuSetting';
import MenuHelp from '../organisms/MenuHelp';
import {
  getMenuGenreOption,
  getMenuSituationOption,
  getMenuUserTargetOption
} from '../../actions/Options';
import GochiMenuAddChooseUsageTypeShop from '../organisms/GochiMenuAddChooseUsageTypeShop';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7'
    }
  },
  root: {
    // backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: 15
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 0,
    padding: 0
  },
  mainContent: {
    padding: '20px 15px',
    margin: '-15px -10px'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupCenter: {
    textAlign: 'center',
    padding: '15px 20px'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  // mainModal: {
  //   zIndex: '99999!important'
  // },
  fs24: {
    fontSize: '24px'
  },
  textCenter: {
    textAlign: 'center',
    padding: 15
  },
  tabpanelHeader: {
    padding: '0 10px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#ffffff',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #F7F7F7',
    width: '50%',
    cursor: 'pointer',

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  btnBack: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20,
    paddingBottom: 20
  },
  showHideGochiPrice: {
    paddingLeft: 25,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  textSwitch: {
    paddingRight: 10
  },
  font14: {
    fontSize: 14
  },
  bold: {
    fontWeight: 'bold'
  },
  buttonSetting: {
    padding: '6px 0px'
  },
  btnHelp: {
    padding: 0,
    minWidth: 0
  },
  settingIcon: {
    fontSize: 18
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      identityStatuses: state.identities.statuses,
      showHides: state.gochiMenus.showHide,
      menuSetting: state.gochiMenus.setting,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getOrderGochiMenus,
          downloadMenu,
          getAccounts,
          getShops,
          getGochiChildFoodLists,
          getChildFoodShops,
          getChildFoodGroups,
          getMenuSetting,
          updateMenuSetting,
          getMenuGenreOption,
          getMenuSituationOption,
          getMenuUserTargetOption
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddChooseUsageType', 'updateOpenAddChooseUsageType', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('shopId', 'setShopId', null),
  withState('orderMenuShopId', 'setOrderMenuShopId', null),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('identityStatus', 'setIdentityStatus', ''),
  withState('showHide', 'setShowHide', ''),
  withState('hasMore', 'setHasMore', true),
  withState('nextHref', 'setNextHref', 1),
  withState('listMenus', 'setListMenus', []),
  withState('valueTab', 'setValueTab', 0),
  withState('groupId', 'setGroupId', null),
  withState('childFoodDescription', 'setChildFoodDescription', ''),
  withState('openAddChildFood', 'updateOpenAddChildFood', false),
  withState('openAddChildFoodConfirm', 'updateOpenAddChildFoodConfirm', false),
  withState('groupId', 'setGroupId', null),
  withState('listMenusChildFood', 'setListMenusChildFood', []),
  withState('hasMoreChildFood', 'setHasMoreChildFood', true),
  withState('nextHrefChildFood', 'setNextHrefChildFood', 1),
  withState('groupId', 'setGroupId', null),
  withState('showGochiPrice', 'setShowGochiPrice', true),
  withState('openMenuSettingModal', 'setOpenMenuSettingModal', false),
  withState('openMenuHelpModal', 'setOpenMenuHelpModal', false),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      setTimeout(() => {
        // if (page === props.nextHref) {

        // }
        const searchKey = {
          page,
          limit
        };

        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions
          .getGochiMenus(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            let list = [];
            if (page > 1) {
              list = props.listMenus;
            } else {
              list = [];
              props.setNextHref(1);
            }

            if (data.type === 'GET_GOCHI_MENUS_SUCCESS') {
              if (data.payload.menus) {
                data.payload.menus.map(menu => {
                  return list.push(menu);
                });
                props.setListMenus(list);
                if (data.payload.offset + 10 < data.payload.totalCount) {
                  props.setHasMore(true);
                } else {
                  props.setHasMore(false);
                }
              }
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            // props.setNextHref(1);
            console.log(error);
          });
      }, 100);
    },
    handleChangePageChildFood: props => (event, page, limit) => {
      setTimeout(() => {
        // if (page === props.nextHref) {

        // }
        const searchKey = {
          page,
          limit
        };

        props.updateLoading(true);
        props.updateOpenProgress(true);
        props.actions
          .getGochiChildFoodLists(searchKey)
          .then(data => {
            // props.checkSession(data);
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            props.updateOpenTable(true);
            let list = [];
            if (page > 1) {
              list = props.listMenusChildFood;
            } else {
              list = [];
              props.setNextHrefChildFood(1);
            }

            if (data.type === 'GET_GOCHI_CHILD_FOOD_SUCCESS') {
              if (data.payload.list) {
                data.payload.list.map(menu => {
                  return list.push(menu);
                });
                props.setListMenusChildFood(list);
                if (data.payload.offset + 10 < data.payload.count) {
                  props.setHasMoreChildFood(true);
                } else {
                  props.setHasMoreChildFood(false);
                }
              }
            }
          })
          .catch(error => {
            props.updateOpenProgress(false);
            props.setResultMessage('');
            props.updateLoading(false);
            // props.setNextHref(1);
            console.log(error);
          });
      }, 100);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        this.props.handleChangePage(null, 1, 10);

        const searchGroupId = queryString.parse(this.props.location.search)
          .groupId;
        this.props.setGroupId(Number(searchGroupId));
        this.props.actions.getChildFoodGroups();
        this.props.actions.getChildFoodShops();

        if (
          data.payload.role === 'SHOP' &&
          (data.payload.belongToChildGroups !== 'undefined' &&
            data.payload.belongToChildGroups.length > 0)
        ) {
          this.props.actions
            .getGochiChildFoodLists({
              page: this.props.page,
              limit: this.props.rowsPerPage
            })
            .then(menuData => this.props.checkSession(menuData));
          this.props.updateOpenTable(true);
          this.props.handleChangePageChildFood(null, 1, 10);
        }
        // if (
        //   !(
        //     data.payload.accountStatus &&
        //     data.payload.accountStatus.status === true
        //   )
        // ) {
        this.props.actions
          .getMenuSetting(data.payload.shopId)
          .then(menuSettingData => {
            if (menuSettingData.type === 'GET_MENU_SETTING_SUCCESS') {
              this.props.checkSession(menuSettingData);
              this.props.setShowGochiPrice(
                _.get(menuSettingData, 'payload.allowMenuPrice', false) === 1
              );
            }
          });
        // }

        // const searchShopId = queryString.parse(this.props.location.search)
        //   .shopId;
        // this.props.setShopId(Number(searchShopId));
        // if (data.payload.role === 'SHOP') {
        //   this.props.actions
        //     .getGochiMenus({
        //       page: this.props.page,
        //       limit: this.props.rowsPerPage
        //     })
        //     .then(menuData => this.props.checkSession(menuData));
        //   this.props.updateOpenTable(true);
        // } else if (searchShopId) {
        //   await this.props.actions
        //     .getGochiMenus({
        //       shopId: searchShopId,
        //       page: this.props.page,
        //       limit: this.props.rowsPerPage
        //     })
        //     .then(async menuData => {
        //       this.props.checkSession(menuData);
        //       if (menuData.payload.menus.length) {
        //         this.props.setShopName(menuData.payload.menus[0].shopName);
        //       } else {
        //         await this.props.actions
        //           .getShops({ shopId: searchShopId })
        //           .then(shopData => {
        //             this.props.checkSession(shopData);
        //             this.props.setShopName(shopData.payload.shops[0].shopName);
        //           });
        //       }
        //     });
        //   this.props.updateOpenTable(true);
        // }
      });
      this.props.actions.getMenuGenreOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuGenre(data.payload);
      });
      this.props.actions.getMenuSituationOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuSituation(data.payload);
      });
      this.props.actions.getMenuUserTargetOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuUserTarget(data.payload);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    handleChangePageChildFood,
    account,
    // openDrawer,
    // updateOpenDrawer,
    openTable,
    // updateOpenTable,
    openAdd,
    updateOpenAdd,
    openAddChooseUsageType,
    updateOpenAddChooseUsageType,
    openAddChildFood,
    updateOpenAddChildFood,
    openAddConfirm,
    updateOpenAddConfirm,
    openViewOrderCustom,
    updateOpenViewOrderCustom,
    openViewOrderCustomList,
    updateOpenViewOrderCustomList,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    shopId,
    setShopId,
    orderMenuShopId,
    setOrderMenuShopId,
    groupName,
    shopName,
    menuName,
    resultMessage,
    setResultMessage,
    page,
    hasMore,
    nextHref,
    setNextHref,
    listMenus,
    valueTab,
    setValueTab,
    openAddChildFoodConfirm,
    updateOpenAddChildFoodConfirm,
    groupId,
    setGroupId,
    setChildFoodDescription,
    hasMoreChildFood,
    nextHrefChildFood,
    setNextHrefChildFood,
    listMenusChildFood,
    handleRedirect,
    showGochiPrice,
    setShowGochiPrice,
    openMenuSettingModal,
    setOpenMenuSettingModal,
    menuSetting,
    openMenuHelpModal,
    setOpenMenuHelpModal,
    menuGenre,
    menuSituation,
    menuUserTarget
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const isChildShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);

    const isChildShopOnly =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      ((account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0) ||
        account.childShopFlag === 1);
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper,
      isChildShop,
      isChildShopOnly
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 100;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      menuName,
      page,
      limit: limitNum
    };

    const loadMoreMenus = async () => {
      setNextHref(nextHref + 1);
      handleChangePage(null, nextHref + 1, 10);
    };

    const loadMoreMenusChildFood = async () => {
      setNextHrefChildFood(nextHrefChildFood + 1);
      handleChangePageChildFood(null, nextHrefChildFood + 1, 10);
    };

    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!shopId) {
          const initialShopId = isShop ? shopData.payload.shops[0].shopId : 0;
          setShopId(initialShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        if (isFukuoka) {
          updateOpenAdd(true);
        } else {
          updateOpenAddChooseUsageType(true);
        }
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const addChildFoodAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getChildFoodShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!shopId) {
          // const shopIdChild =
          //   shopData.payload.list.length > 0
          //     ? shopData.payload.list[0].shopId
          //     : account.shopId;
          // const initialShopId = isChildShop ? shopIdChild : 0;
          setShopId(account.shopId);
        }
        setShopId(account.shopId);
        updateOpenProgress(false);
        updateLoading(false);
        updateOpenAddChildFood(true);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const viewOrderCustomAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!orderMenuShopId) {
          const initialOrderMenuShopId = isShop
            ? shopData.payload.shops[0].shopId
            : 0;
          setOrderMenuShopId(initialOrderMenuShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        updateOpenViewOrderCustom(true);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };
    const handleChangeTab = (event, newValue) => {
      setValueTab(newValue);
    };

    const showHideOpenAction = param => {
      updateLoading(true);
      updateOpenProgress(true);
      const dataParams = {
        params: {
          allowMenuPrice: !param ? 1 : 0
        },
        shopId: account.shopId
      };
      actions
        .updateMenuSetting(dataParams)
        .then(data => {
          // console.log(data);
          if (data.type === 'UPDATE_MENU_SETTING_SUCCESS') {
            actions
              .getMenuSetting(account.shopId)
              .then(menuSettingData => {
                if (menuSettingData.type === 'GET_MENU_SETTING_SUCCESS') {
                  updateOpenProgress(false);
                  setShowGochiPrice(!param);
                  updateLoading(false);
                }
              })
              .catch(() => {
                updateOpenProgress(false);
                updateLoading(false);
              });
          }
        })
        .catch(() => {
          updateOpenProgress(false);
          updateLoading(false);
        });
    };

    const backAction = () => handleRedirect('/release_step');

    const handleSetDataMenuSetting = data => {
      setShowGochiPrice(_.get(data, 'allowMenuPrice', false) === 1);
    };

    return (
      <div className={classes.root}>
        <CssBaseline />
        {isReleased ? <Header /> : <PublicHeader />}
        <div className={classes.pageTitileDiv}>
          <Typography color="textPrimary" className={classes.fs24}>
            {isFukuoka ? 'コース情報管理' : 'メニュー情報管理'}
          </Typography>
        </div>
        {!isReleased && isShop && (
          <div className={classes.pageTitileDiv}>
            <Typography color="textPrimary">
              「ごちチケット」「お値段ごち」の他に、必ず一品以上のメニュー登録が必要です。
              <br />
              メニュー作り方の例は
              <Button
                variant="text"
                color="primary"
                onClick={() => setOpenMenuHelpModal(true)}
                className={classes.btnHelp}
              >
                こちら
              </Button>
            </Typography>
          </div>
        )}
        {isChildShop && (
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            centered
            className={classes.tabpanelHeader}
          >
            <Tab
              label="通常メニュー"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 0 && classes.tabSelected
              )}
            />
            <Tab
              label="こども食堂メニュー"
              className={classNames(
                classes.btnTabpanel,
                valueTab === 1 && classes.tabSelected
              )}
            />
          </Tabs>
        )}
        <TabPanelDetail value={valueTab} index={0}>
          <div className={classes.mainContent}>
            <Paper className={classes.mainPaper} elevation={3}>
              <div className={classes.buttonGroupCenter}>
                <MenuRegisterButton
                  onClickAction={addAction}
                  btnText={isFukuoka ? 'コース追加' : 'メニュー追加'}
                />
                <MenuViewOrderEditButton
                  onClickAction={viewOrderCustomAction}
                  isFukuoka={isFukuoka}
                />
              </div>
              {isShop && !isFukuoka && (
                <>
                  {/* <div className={classes.showHideGochiPrice}>
                    <Button
                      color="primary"
                      onClick={() => setOpenMenuSettingModal(true)}
                      className={classes.buttonSetting}
                    >
                      <SettingsIcon className={classes.settingIcon} />
                      <Text className={[classes.bold, classes.font14]}>
                        メニューの標準設定
                      </Text>
                    </Button>
                  </div> */}
                  <div className={classes.showHideGochiPrice}>
                    <>
                      <Typography className={classes.textSwitch}>
                        <Text className={[classes.bold, classes.font14]}>
                          お値段ごち表示
                        </Text>
                      </Typography>
                      <ShowHideSwitchButton
                        params={showGochiPrice}
                        onClickAction={showHideOpenAction}
                        showHide={showGochiPrice ? 1 : 0}
                      />
                    </>
                  </div>
                </>
              )}

              {openTable && (
                <GochiMenuTableShop
                  searchKey={searchKey}
                  roles={roles}
                  progress={progress}
                  page={page}
                  handleChangePage={handleChangePage}
                  selectedPage={nextHref}
                  listMenus={listMenus}
                  account={account}
                  menuGenre={menuGenre}
                  menuSituation={menuSituation}
                  menuUserTarget={menuUserTarget}
                  isFukuoka={isFukuoka}
                />
              )}

              <div>
                <Modal open={openAdd} className={classes.modalMobile}>
                  <GochiMenuAddShop
                    openAddConfirm={openAddConfirm}
                    updateOpenAdd={updateOpenAdd}
                    updateOpenAddConfirm={updateOpenAddConfirm}
                    searchKey={searchKey}
                    shopId={shopId}
                    setShopId={setShopId}
                    roles={roles}
                    handleChangePage={handleChangePage}
                    menuGenre={menuGenre}
                    menuSituation={menuSituation}
                    menuUserTarget={menuUserTarget}
                    isFukuoka={isFukuoka}
                  />
                </Modal>
              </div>
              <div>
                <Modal
                  open={openAddChooseUsageType}
                  className={classes.modalMobile}
                >
                  <GochiMenuAddChooseUsageTypeShop
                    updateOpenAddChooseUsageType={updateOpenAddChooseUsageType}
                    searchKey={searchKey}
                    shopId={shopId}
                    setShopId={setShopId}
                    handleChangePage={handleChangePage}
                    menuGenre={menuGenre}
                    openAddChooseUsageType={openAddChooseUsageType}
                  />
                </Modal>
              </div>
              <div>
                <Modal open={openViewOrderCustom} className={classes.mainModal}>
                  <MenuViewOrderCustomShop
                    updateOpenViewOrderCustom={updateOpenViewOrderCustom}
                    openViewOrderCustomList={openViewOrderCustomList}
                    updateOpenViewOrderCustomList={
                      updateOpenViewOrderCustomList
                    }
                    orderMenuShopId={orderMenuShopId}
                    setOrderMenuShopId={setOrderMenuShopId}
                    searchKey={searchKey}
                    handleChangePage={handleChangePage}
                    isFukuoka={isFukuoka}
                  />
                </Modal>
              </div>
              <ProgressDialog openProgress={openProgress} loading={loading} />
            </Paper>
            {isShop && !isReleased && (
              <div className={classes.btnBack}>
                <Button variant="text" color="primary" onClick={backAction}>
                  <Text className={[classes.bold, classes.font14]}>
                    TOPへ戻る
                  </Text>
                </Button>
              </div>
            )}
            {hasMore && (
              <div className={classes.textCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  // className={classes.buttonSend}
                  onClick={() => {
                    loadMoreMenus();
                  }}
                >
                  もっと見る
                </Button>
              </div>
            )}
          </div>
        </TabPanelDetail>

        <TabPanelDetail value={valueTab} index={1}>
          <div className={classes.mainContent}>
            <Paper className={classes.mainPaper} elevation={3}>
              <div className={classes.buttonGroupCenter}>
                <MenuRegisterButton onClickAction={addChildFoodAction} />
              </div>

              <GochiChildFoodShop
                progress={progress}
                handleChangePageChildFood={handleChangePageChildFood}
                selectedPage={nextHrefChildFood}
                listMenus={listMenusChildFood}
              />
            </Paper>

            {hasMoreChildFood && (
              <div className={classes.textCenter}>
                <Button
                  variant="contained"
                  color="primary"
                  size="xs"
                  // className={classes.buttonSend}
                  onClick={() => {
                    loadMoreMenusChildFood();
                  }}
                >
                  もっと見る
                </Button>
              </div>
            )}

            <div>
              <Modal open={openAddChildFood} className={classes.modalMobile}>
                <GochiChildFoodListAddShop
                  openAddChildFoodConfirm={openAddChildFoodConfirm}
                  updateOpenAddChildFood={updateOpenAddChildFood}
                  updateOpenAddChildFoodConfirm={updateOpenAddChildFoodConfirm}
                  shopId={shopId}
                  setShopId={setShopId}
                  groupId={groupId}
                  setGroupId={setGroupId}
                  setChildFoodDescription={setChildFoodDescription}
                  handleChangePageChildFood={handleChangePageChildFood}
                />
              </Modal>
            </div>
          </div>
        </TabPanelDetail>
        <Modal open={openMenuSettingModal} className={classes.modalMobile}>
          <MenuSetting
            setOpenMenuSettingModal={setOpenMenuSettingModal}
            shopId={account.shopId}
            menuSetting={menuSetting}
            isEdit
            setDataToParrent={handleSetDataMenuSetting}
            handleChangePage={handleChangePage}
          />
        </Modal>
        <Modal open={openMenuHelpModal} className={classes.modalMobile}>
          <MenuHelp setOpenHelpModal={setOpenMenuHelpModal} />
        </Modal>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
        {isReleased && <MenuBox account={account} />}
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
